<template>
  <div class="step-one-content">
    <div :class="{ 'plans-wrapper': true, 'global-discount-is-active':  globalDiscountIsActive }">
      <div :class="['plan-line', planLineClass]" v-if="plans.length > 0">
        <span v-for="(plan, index) in plans" :key="index"
          :class="{
            'plan-point': true,
            'active': planPointIsActive(index)
          }"
        ></span>
      </div>
      <div class="plans-carousel-view">
        <transition-group :class="['plans-carousel', plansCarouselClass]">
          <div
            v-for="(plan, index) in plans"
            :key="`plan-${index}`"
            :class="{
              'plan': true,
              'active': planIsActive(index),
              'has-tooltip disabled': planIsDisabled(index)
            }"
            v-touch:swipe="swipeHandler"
          >
            <span
              v-if="planIsDisabled(index)"
              class="tooltip"
            >
              Obecnie posiadasz plan {{ user.planName }}. Przejście na niższy plan {{ plan.name }} będzie możliwe dopiero po zakończeniu bieżącego planu.
            </span>
            <div v-if="planIsPremium(plan)" class="plan-label">
              Najpopularniejszy
            </div>
            <div v-if="planIsVip(plan)" class="vip-plan-label">
              Dołącz do elity<br>
              <hr>
              NAJLEPSZA OPŁACALNOŚĆ
            </div>
            <div v-on:click="selectPlan(index)" class="plan-content">
              <p class="plan-name">
                <span v-if="planIsVip(plan)" class="stars">
                  <span class="star--vip"></span>
                  <span class="star--vip"></span>
                  <span class="star--vip"></span>
                </span>
                {{ plan.name }}
                <span v-if="planIsVip(plan)" class="stars">
                  <span class="star--vip"></span>
                  <span class="star--vip"></span>
                  <span class="star--vip"></span>
                </span>
              </p>
              <div class="price-wrapper" v-if="plan.lowestPricePromo">
                <div class="price-with-out-discount-label">
                  <span>{{ plan.lowestPrice }}</span> PLN/netto
                </div>
                <div class="price">
                  <span class="price-prefix">od</span>
                  <span class="price-integer">{{ priceInteger(plan.lowestPricePromo) }}</span>
                  <span class="price-sufix">
                    <span class="price-decimal-places">,{{ priceNonInteger(plan.lowestPricePromo) }}</span><br>
                    <span>PLN</span><br>
                    netto/miesięcznie
                  </span>
                </div>
              </div>
              <div class="price-wrapper" v-else>
                <div class="price-with-out-discount-label" v-if="globalDiscountIsActive">
                  <span></span>
                </div>
                <div class="price">
                  <span class="price-prefix">od</span>
                  <span class="price-integer">{{ priceInteger(plan.lowestPrice) }}</span>
                  <span class="price-sufix">
                    <span class="price-decimal-places">,{{ priceNonInteger(plan.lowestPrice) }}</span><br>
                    <span>PLN</span><br>
                    netto/miesięcznie
                  </span>
                </div>
              </div>
              <div
                v-for="(feature, index) in mainFeatures[plan.name]"
                :key="`feature-${index}`"
                :class="{ 'plan-property--first': index === 5 }"
                class="plan-property"
              >{{ feature }}</div>
            </div>
          </div>
        </transition-group>
      </div>
      <div class="navigation-dots">
        <div
          v-for="(plan, index) in plans"
          :key="index"
          :class="{
            dot: true,
            active: planIsActive(index),
            disabled: planIsDisabled(index)
          }"
          v-on:click="selectPlan(index)"
        ></div>
      </div>
    </div>
    <div class="flex-right">
      <div class="price-info">
        *podane ceny dotyczą planów dwuletnich
      </div>
    </div>
    <div class="list-plan-details">
      <div
        v-for="(plan, index) in plans"
        v-if="planIsActive(index)"
        :key="index"
        class="plan-details"
      >
        <div class="big-plan-name">Pakiet {{ plan.name }}</div>
        <div class="plan-description">{{ description[plan.name] }}</div>
        <div class="detail-features">
          <div class="detail-feature" v-for="(feature, index) in detailFeatures[plan.name]" :key="index">
            <span>{{ feature.colorPart }}</span> {{ feature.normalPart }}
          </div>
        </div>
        <div class="grey-label">PAKIET OBEJMUJE</div>
          <ul class="plan-features">
            <li
              v-for="(feature, index) in allFeatures[plan.name]"
              :key="index"
              :class="{
                'has-tooltip': feature.tooltipText != '',
                'available': feature.isAvailable,
                'unavailable': feature.isAvailable == false
              }"
            >
              {{ feature.text }}
              <span class="tooltip">{{ feature.tooltipText }} </span>
            </li>
        </ul>
      </div>
    </div>
<!--
    <div class="row">
      <div class="more-info">
        Prowadzisz duże przedsiębiorstwo? <a href="https://kcalmar.com/dietetyk/kontakt/">Poznaj indywidualne warunki</a>
      </div>
    </div>
-->
    <div class="button-wrapper">
      <router-link :to="{ name: 'PaymentStepExtra' }" class="skip-step-button">
        Nie chcę planu, chcę tylko dodatki
      </router-link>
      <router-link :to="{ name: 'PaymentStepPeriod' }" class="next-step-button button">
        Wybieram pakiet {{ selectedPlanName }}
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex'

export default {
  name: 'PaymentStepPlan',
  computed: {
    ...mapState([
      'selectedPlanIndex',
      'plans',
      'user'
    ]),
    ...mapGetters([
      'selectedPlanName'
    ]),
    planLineClass: function () {
      return 'l' + this.selectedPlanIndex
    },
    plansCarouselClass: function () {
      return 'p' + this.selectedPlanIndex
    },
    globalDiscountIsActive () {
      for (var i = 0; i < this.plans.length; i++) {
        const plan = this.plans[i]
        if (plan.lowestPricePromo !== null) {
          return true
        }
      }
      return false
    },
    planData () {
      const dataDict = {
        userPlanName: '',
        availablePlans: []
      }
      dataDict.userPlanName = this.user.planName
      dataDict.availablePlans = this.plans
      return dataDict
    }
  },
  methods: {
    ...mapMutations([
      'selectPlan'
    ]),
    planPointIsActive (index) {
      return this.selectedPlanIndex >= index
    },
    planIsActive (index) {
      return this.selectedPlanIndex === index
    },
    planIsDisabled (index) {
      if (this.user.planName) {
        let currentPlanIndex = this.plans.findIndex(p => p.name === this.user.planName)
        let planMap = {
          'Master 2018': 1,
          'Master+Szablony 2018': 1,
          'Premium 2018': 2,
          'Edu-Premium': 2
        }
        if (currentPlanIndex === -1 && planMap.hasOwnProperty(this.user.planName)) {
          currentPlanIndex = planMap[this.user.planName]
        }
        if (currentPlanIndex > index) {
          return true
        }
      }
      return false
    },
    planIsVip (plan) {
      return plan.name === 'VIP'
    },
    planIsPremium (plan) {
      return plan.name === 'Premium'
    },
    swipeHandler (direction) {
      if (direction === 'left') {
        if (this.selectedPlanIndex < this.plans.length - 1) {
          this.selectPlan(this.selectedPlanIndex + 1)
        }
      } else if (direction === 'right') {
        if (this.selectedPlanIndex > 0 && !this.planIsDisabled(this.selectedPlanIndex - 1)) {
          this.selectPlan(this.selectedPlanIndex - 1)
        }
      }
    },
    priceInteger: function (price) {
      // Returns integer of decimal in example 55 from 55.24
      if (price) {
        return price.toFixed(2).toString().split('.')[0]
      }
      return '0'
    },
    priceNonInteger: function (price) {
      // Returns deciaml places of decimal in example 24 from 55.24
      if (price) {
        return price.toFixed(2).toString().split('.')[1]
      }
      return '0.00'
    }
  },
  watch: {
    planData (data) {
      if (this.$route.params.current_plan) {
        if (data.availablePlans.length > 0 && data.userPlanName !== '') {
          let cpIndex = parseInt(this.$route.params.current_plan)
          let spIndex = this.selectedPlanNameDict[data.userPlanName]
          if (spIndex === undefined) {
            spIndex = 3
          }
          if (this.plans.length > cpIndex && cpIndex >= 0 && cpIndex >= spIndex) {
            this.selectPlan(cpIndex)
          } else {
            this.selectPlan(spIndex)
          }
        } else {
          this.selectPlan(0)
        }
      } else {
        this.selectPlan(this.plans.length - 1)
      }
    }
  },
  created: function () {
    if (this.$store.state.selectedPlanIndex === null) {
      this.$store.commit('selectPlan', this.plans.length - 1)
    }
    this.$store.commit('selectPeriod', null)
  },
  beforeRouteLeave (to, from, next) {
    if (to.name === 'PaymentStepExtra') {
      this.$store.commit('selectPlan', null)
    }
    next()
  },
  data: function () {
    return {
      selectedPlanNameDict: {
        'Basic': 0,
        'Student 2018': 0,
        'Testowy': 0,
        'Master': 1,
        'Master+Szablony 2018': 1,
        'Master 2018': 1,
        'Premium': 2,
        'Premium 2018': 2,
        'Edu-Premium': 2,
        'VIP': 3
      },
      description: {
        'Basic': 'Idealny dla początkujących dietetyków i studentów zdobywających doświadczenie w układaniu planów żywieniowych. Błyskawicznie twórz jadłospisy dzięki rozbudowanej bazie produktów i potraw. Obliczaj zapotrzebowanie energetyczne Twojego Pacjenta, dzięki systemowym kalkulatorom energii oraz wartości odżywczych. Pozyskuj nowych pacjentów poprzez profil publiczny w serwisie Kcalmar.com. Udostępniaj Pacjentom ułożone jadłospisy dzięki dedykowanej aplikacji mobilnej  Kcalmar – dieta i przepisy.',
        'Master': ' Idealny dla dietetyków i trenerów, którzy dbają o budowanie wizerunku swojej marki. Zyskujesz wszystkie funkcje planu Basic, a także dodatkowe szablony wydruku z własnym logo. Dokładnie bilansuj jadłospisy poprzez dostęp do 101 wskaźników i wartości odżywczych oraz możliwości śledzenia realizacji najnowszych Norm żywienia 2024. Zwiększ efektywność swojej pracy, dzięki dostępowi do większej liczby jadłospisów systemowych, zaawansowanej wyszukiwarki potraw oraz możliwości porządkowania jadłospisów na katalogi.',
        'Premium': 'Idealny dla nowoczesnych dietetyków, którzy dbają o jak największą efektywność swojej pracy. Pracuj wygodnie i oszczędzaj czas, dzięki wszystkim funkcjom planów Basic, Master oraz błyskawicznej podmianie składnika na całym jadłospisie. Twórz zróżnicowane plany żywieniowe, dzięki podglądowi powtarzających się potraw. Zmieniaj kaloryczność jadłospisu za pomocą jednego przycisku. Stwórz jadłospisy dopasowane do Pacjenta, dzięki funkcji monitorowania alergenów, produktów lubianych i nielubianych. W prosty sposób przenoś dane Pacjenta do systemu dzięki integracji z analizatorem składu ciała. Cofnij wprowadzone zmiany, dzięki funkcji „Cofnij/ponów”.',
        'VIP': 'Idealny dla elitarnych dietetyków i trenerów, którzy szukają kompletnych usług w jednym miejscu. Zyskujesz wszystkie funkcje planów Basic, Master i Premium. Poszerzaj swoją wiedzę, dzięki dostępowi do wszystkich szkoleń Instytutu Edukacji Żywieniowej, które odbędą się w trakcie trwania Twojego planu. Pozyskuj większą liczbę Klientów, dzięki wyróżnieniu Twojego profilu w serwisie dla Pacjentów. Przesyłaj jadłospisy innym dietetykom, dzięki funkcji udostępniania jadłospisu. Oszczędzaj pieniądze, dzięki specjalnym zniżkom dla użytkowników VIP.'
      },
      mainFeatures: {
        'Basic': [
          'Kreator jadłospisów',
          'Baza IŻŻ',
          'Profil publiczny'
        ],
        'Master': [
          '101 wskaźników i wartości odżywczych',
          'Własne logo',
          'Zaawansowana wyszukiwarka potraw'
        ],
        'Premium': [
          'Skalowanie kaloryczności jadłospisów',
          'Błyskawiczna zamiana produktów',
          'Podgląd powtarzających się potraw'
        ],
        'VIP': [
          'Dostęp do szkoleń IEŻ',
          'Wyróżnienie profilu dietetyka',
          'Udostępnianie diet dietetykom'
        ]
      },
      detailFeatures: {
        'Basic': [
          {
            'colorPart': '12',
            'normalPart': 'graficznych szablonów wydruku'
          },
          {
            'colorPart': 'do 1500',
            'normalPart': 'potraw z przepisami'
          },
          {
            'colorPart': '14',
            'normalPart': 'jadłospisów systemowych'
          }
        ],
        'Master': [
          {
            'colorPart': '19',
            'normalPart': 'graficznych szablonów wydruku'
          },
          {
            'colorPart': 'do 2000',
            'normalPart': 'potraw z przepisami'
          },
          {
            'colorPart': '23',
            'normalPart': 'jadłospisów systemowych'
          }
        ],
        'Premium': [
          {
            'colorPart': '26',
            'normalPart': 'graficznych szablonów wydruku'
          },
          {
            'colorPart': 'Nieograniczona',
            'normalPart': 'liczba potraw z przepisami'
          },
          {
            'colorPart': '37',
            'normalPart': 'jadłospisów systemowych'
          }
        ],
        'VIP': [
          {
            'colorPart': '32',
            'normalPart': 'graficzne szablony wydruku'
          },
          {
            'colorPart': 'Nieograniczona',
            'normalPart': 'liczba potraw z przepisami'
          },
          {
            'colorPart': '55',
            'normalPart': 'jadłospisy systemowe'
          }
        ]
      },
      allFeatures: {
        'Basic': [
          {
            text: 'Błyskawiczny kreator jadłospisów',
            tooltipText: 'Twórz jadłospisy w prosty i efektywny sposób dzięki naszemu nowoczesnemu narzędziu.',
            isAvailable: true
          },
          {
            text: 'Dostęp do pełnej bazy produktów IŻŻ',
            tooltipText: 'Bogata baza produktów IŻŻ uzupełniona o produkty z bazy USDA, UK, NCCDB, bazy Szwajcarskiej, z możliwością rozbudowy prywatnej bazy produktów.',
            isAvailable: true
          },
          {
            text: 'Możliwość dodawania własnych produktów i potraw',
            tooltipText: 'Ponad 1100 potraw systemowych. Maksymalny limit dla poszczególnych pakietów określony powyżej',
            isAvailable: true
          },
          {
            text: 'Możliwość komponowania potraw wieloporcjowych wraz z informacją o niewykorzystanych porcjach',
            tooltipText: 'Umieszczaj w diecie dania, które możesz podzielić na kilka porcji a następnie wykorzystać je w kolejnych dniach.',
            isAvailable: true
          },
          {
            text: 'Szybką edycję potraw bezpośrednio na jadłospisie (widok dzienny i tygodniowy)',
            tooltipText: 'Wybierz wygodny dla siebie sposób edycji diety.',
            isAvailable: true
          },
          {
            text: 'Dodawanie komentarzy do posiłków oraz komentarza tygodniowego',
            tooltipText: 'Dziel się wskazówkami i dodatkowymi zaleceniami ze swoimi pacjentami.',
            isAvailable: true
          },
          {
            text: 'Ułatwiony dostęp do historii jadłospisów pacjenta (6 miesięcy wstecz)',
            tooltipText: 'Korzystaj z dodatkowej zakładki z podsumowaniem archiwalnych jadłospisów. Pamiętaj, że cały czas masz do nich dostęp, wystarczy wejść w bieżący tydzień i użyć strzałek na kalendarzu.',
            isAvailable: true
          },
          {
            text: 'Dostęp do historii przeliczeń (do 1 miesiąca wstecz)',
            tooltipText: 'Monitoruj postępy Pacjenta na podstawie historii przeliczeń BMI, masy ciała, zapotrzebowania energetycznego (CPM, PPM), zawartości tkanki tłuszczowej.',
            isAvailable: true
          },
          {
            text: 'Dostęp do panelu ze szkoleniami',
            tooltipText: 'Zdobywaj dodatkową wiedzę dzięki szkoleniom, które możesz wykupić bezpośrednio w naszym programie.',
            isAvailable: true
          },
          {
            text: 'Profil publiczny w serwisie dla pacjentów',
            tooltipText: 'Pozyskuj pacjentów przez promowanie usług dietetycznych w serwisie dla pacjentów Kcalmar.com.',
            isAvailable: true
          },
          {
            text: 'Szczegółowy, systemowy wywiad żywieniowy',
            tooltipText: 'Uzyskaj szczegółowe informacje na temat pacjenta, dzięki szczegółowej ankiecie żywieniowej.',
            isAvailable: true
          },
          {
            text: 'Możliwość kopiowania potraw, dni i całych jadłospisów',
            tooltipText: 'Oszczędzaj czas dzięki możliwości łatwego i szybkiego kopiowania.',
            isAvailable: true
          },
          {
            text: 'Jadłospisy w formacie PDF',
            tooltipText: 'Generuj plik gotowy do wydruku lub do przekazania pacjentowi drogą elektroniczną.',
            isAvailable: true
          },
          {
            text: 'Aplikację mobilną dla pacjenta',
            tooltipText: 'Udostępnij dietę pacjentowi poprzez aplikację mobilną dostępną na systemy Android i iOS.',
            isAvailable: true
          },
          {
            text: 'Panel pacjenta na stronie internetowej',
            tooltipText: 'Dostęp pacjenta do jadłospisów na stronie internetowej po rejestracji konta.',
            isAvailable: true
          },
          {
            text: 'Automatyczną listę zakupów',
            tooltipText: 'Wygodna lista zakupów generowana na podstawie przygotowanego jadłospisu.',
            isAvailable: true
          },
          {
            text: 'Miary domowe produktów',
            tooltipText: 'Wartości wyrażone w gramach są uzupełnione o podpowiedzi dla pacjenta w postaci wygodnych miar domowych',
            isAvailable: true
          },
          {
            text: 'Możliwość ustawienia kolejności, czasu i założonego procentowego rozkładu energii posiłków',
            tooltipText: 'Twórz posiłki o zbliżonej kaloryczności dzięki procentowemu rozkładowi energii. Ustalaj pory posiłków oraz ich kolejność.',
            isAvailable: true
          },
          {
            text: 'Wyszukiwanie jadłospisów po nazwie',
            tooltipText: 'Pracuj efektywniej dzięki szybkiej wyszukiwarce jadłospisów.',
            isAvailable: true
          },
          {
            text: 'Podstawowe wartości odżywcze',
            tooltipText: 'Twórz zbilansowane jadłospisy dzięki dostępowi do kaloryczności jadłospisu, zawartości białka, tłuszczów, węglowodanów oraz błonnika.',
            isAvailable: true
          },
          {
            text: 'Duplikowanie jadłospisów (także systemowych)',
            tooltipText: 'Twórz błyskawiczne jadłospisy dzięki możliwości kopiowania gotowych jadłospisów, a następnie ich edycji.',
            isAvailable: true
          },
          {
            text: 'Porządkowanie jadłospisów w grupy',
            tooltipText: 'Uporządkuj stworzone diety w wygodne grupy.',
            isAvailable: true
          },
          {
            text: 'Możliwość przejścia na wyższy pakiet w dowolnym momencie',
            tooltipText: 'Przejdź na wyższy pakiet w dowolnym momencie. Skontaktuj się z nami w celu uzyskania szczegółowych informacji.',
            isAvailable: true
          },
          {
            text: 'Nielimitowaną liczbę jadłospisów do ułożenia',
            tooltipText: 'Twórz jadłospisy bez ograniczeń.',
            isAvailable: true
          },
          {
            text: 'Automatyczne przeliczanie wskaźników BMI, CPM, PPM, NMC oraz współczynnika PAL',
            tooltipText: 'Obliczaj zapotrzebowanie pacjenta dzięki zintegrowanym kalkulatorom.',
            isAvailable: true
          },
          {
            text: 'Nieograniczoną liczbę pacjentów',
            tooltipText: 'Buduj swoją bazę pacjentów bez ograniczeń.',
            isAvailable: true
          },
          {
            text: 'Automatyczne wyliczanie zapotrzebowania energetycznego w zależności od parametrów pacjenta',
            tooltipText: 'Twórz zbilansowane diety, które pokryją zapotrzebowanie Twojego pacjenta.',
            isAvailable: true
          },
          {
            text: 'Dostęp do 101 wskaźników i wartości odżywczych produktów oraz potraw',
            tooltipText: 'Twórz profesjonalne jadłospisy dzięki dostępowi do informacji o zawartości składników mineralnych, witamin, kwasów tłuszczowych i innych.',
            isAvailable: false
          },
          {
            text: 'Oznaczenie indeksu i ładunku glikemicznego na jadłospisie',
            tooltipText: 'Przygotuj jadłospis o niskim ładunku glikemicznym dzięki oznaczeniu IG i ŁG.',
            isAvailable: false
          },
          {
            text: 'Obliczanie wymienników węglowodanowych i białkowo-tłuszczowych',
            tooltipText: 'Przeliczaj przygotowane na jadłospisie potrawy i produkty na WW i WBT.',
            isAvailable: false
          },
          {
            text: 'Możliwość dodania własnego logo na wydruku jadłospisów',
            tooltipText: 'Promuj swoją markę dzięki spersonalizowanym wydrukom z własnym logo.',
            isAvailable: false
          },
          {
            text: 'Dodatkowe szablony graficzne wydruku z możliwością edycji',
            tooltipText: 'Wybieraj wzory graficzne jadłospisów, ukrywaj na wydruku wybrane informacje. Skorzystaj z grupowania po dniach i posiłkach a także sortowania listy zakupów.',
            isAvailable: false
          },
          {
            text: 'Zaawansowaną wyszukiwarkę produktów i potraw',
            tooltipText: 'Wyszukuj produkty i potrawy dzięki szczegółowym filtrom.',
            isAvailable: false
          },
          {
            text: 'Wizualną ocenę postępów pacjenta na wykresach',
            tooltipText: 'Monitoruj zmiany parametrów pacjenta.',
            isAvailable: false
          },
          {
            text: 'Monitorowanie realizacji norm żywienia 2024',
            tooltipText: 'Monitoruj realizację najnowszych norm żywieniowych.',
            isAvailable: false
          },
          {
            text: 'Funkcję "Cofnij/Ponów"',
            tooltipText: 'Cofnij lub ponów wprowadzone na jadłospisie zmiany jednym kliknięciem (do 5 akcji).',
            isAvailable: false
          },
          {
            text: 'Możliwość dodawania własnych pytań do wywiadu żywieniowego',
            tooltipText: 'Spersonalizuj wywiad żywieniowy dzięki możliwości dodania własnych otwartych pytań.',
            isAvailable: false
          },
          {
            text: 'Drukowanie/pobieranie ankiety żywieniowej',
            tooltipText: 'Pobierz a następnie prześlij lub wydrukuj wywiad żywieniowy dla pacjenta.',
            isAvailable: false
          },
          {
            text: 'Możliwość umawiania wizyt przez pacjentów na stronie Kcalmar.com',
            tooltipText: 'Zwiększaj liczbę pacjentów dzięki funkcji "Zapytaj o termin".',
            isAvailable: false
          },
          {
            text: 'Monitorowanie alergenów, nietolerancji oraz preferencji żywieniowych poprzez system graficznych podpowiedzi',
            tooltipText: 'Zostań powiadomiony przez system w przypadku użycia na jadłospisie alergenów, produktów nietolerowanych oraz lubianych lub nie.',
            isAvailable: false
          },
          {
            text: 'Automatyczne skalowanie kaloryczności jadłospisów',
            tooltipText: 'Ustal nową kaloryczność skopiowanego jadłospisu a system automatycznie przeliczy zapotrzebowa  na produkty.',
            isAvailable: false
          },
          {
            text: 'Dodatkowy rozkład białek, tłuszczów i węglowodanów posiłku na widoku tygodniowym',
            tooltipText: 'Monitoruj rozkład białka, tłuszczu i węglowodanów dzięki graficznym podpowiedziom w widoku tygodniowym.',
            isAvailable: false
          },
          {
            text: 'Zamianę produktów jednym kliknięciem na całym jadłospisie',
            tooltipText: 'Błyskawicznie edytuj jadłospis dzięki możliwości podmiany składnika z poziomu listy zakupów.',
            isAvailable: false
          },
          {
            text: 'Podgląd powtarzających się potraw',
            tooltipText: 'Uatrakcyjnij swoje diety dzięki podpowiedziom o powtarzających się potrawach z ubiegłych tygodni u danego pacjenta.',
            isAvailable: false
          },
          {
            text: 'Wykorzystywanie systemowych tagów potraw i filtrowanie ich na jadłospisie',
            tooltipText: 'Wykorzystaj tagi "paleo", "potreningowy", "szybki", "fit", "z niskim IG" przy tworzeniu własnych potraw a następnie znajdź je w zaawansowanej wyszukiwarce.',
            isAvailable: false
          },
          {
            text: 'Integrację z analizatorami składu ciała',
            tooltipText: 'Wgrywaj automatycznie dane z analizatorów InBody 120 oraz 270, a także Tanita MC-580, MC-780, BC-1000, SC-240, DC-360, DC-430.',
            isAvailable: false
          },
          {
            text: 'Możliwość uwzględnienia strat talerzowych',
            tooltipText: 'Uwzględnij w diecie resztki talerzowe, kotłowe oraz odpadki kuchenne.',
            isAvailable: false
          },
          {
            text: 'Zaawansowane wyszukiwanie posiłków dla diet wegańskich, wegetariańskich, bezglutenowych i bezmlecznych',
            tooltipText: 'Dostosuj szybko dietę do specjalnych preferencji pacjenta.',
            isAvailable: false
          },
          {
            text: 'Możliwość edycji norm żywienia 2024',
            tooltipText: 'Możliwość personalizacji norm dla danego pacjenta.',
            isAvailable: false
          },
          {
            text: 'Możliwość ukrycia logo Kcalmar.pro oraz informacji o aplikacji mobilnej z wydruku',
            tooltipText: 'Generuj spersonalizowane wydruki pdf dzięki opcji ukrycia informacji o możliwości odbioru diety poprzez aplikację mobilną Kcalmar - Pacjent.',
            isAvailable: false
          },
          {
            text: 'Możliwość udostępniania jadłospisów innym dietetykom',
            tooltipText: 'Przekaż gotowy jadłospis wybranemu dietetykowi posiadającemu konto w programie Kcalmar.pro.',
            isAvailable: false
          },
          {
            text: 'Dostęp do certyfikowanych szkoleń Kcalmar.pro, które odbędą się w czasie trwania planu',
            tooltipText: 'Obejmuje wszystkie szkolenia z cyklu IEŻ, które odbędą się w trakcie trwania Twojego planu.',
            isAvailable: false
          },
          {
            text: 'Możliwość publikacji artykułów na blogu Kcalmar.com dla pacjentów',
            tooltipText: 'Publikuj artykuły na blogu Kcalmar.com, aby dotrzeć do większej liczby pacjentów.',
            isAvailable: false
          },
          {
            text: 'Promowanie profilu w wyszukiwarce dietetyków',
            tooltipText: 'Wyróżnij się w wyszukiwarce dietetyków Kcalmar dla pacjentów.',
            isAvailable: false
          },
          {
            text: 'Dodatkowe zniżki i specjalne oferty',
            tooltipText: 'Skorzystaj z preferencyjnych rabatów na oferty Kcalmar.pro i IEŻ.',
            isAvailable: false
          },
          {
            text: 'Twojego osobistego doradcę',
            tooltipText: 'Rozwiązuj problemy z pomocą konsultanta.',
            isAvailable: false
          }
        ],
        'Master': [
          {
            text: 'Błyskawiczny kreator jadłospisów',
            tooltipText: 'Twórz jadłospisy w prosty i efektywny sposób dzięki naszemu nowoczesnemu narzędziu.',
            isAvailable: true
          },
          {
            text: 'Dostęp do pełnej bazy produktów IŻŻ',
            tooltipText: 'Bogata baza produktów IŻŻ uzupełniona o produkty z bazy USDA, UK, NCCDB, bazy Szwajcarskiej, z możliwością rozbudowy prywatnej bazy produktów.',
            isAvailable: true
          },
          {
            text: 'Możliwość dodawania własnych produktów i potraw',
            tooltipText: 'Ponad 1100 potraw systemowych. Maksymalny limit dla poszczególnych pakietów określony powyżej',
            isAvailable: true
          },
          {
            text: 'Możliwość komponowania potraw wieloporcjowych wraz z informacją o niewykorzystanych porcjach',
            tooltipText: 'Umieszczaj w diecie dania, które możesz podzielić na kilka porcji a następnie wykorzystać je w kolejnych dniach.',
            isAvailable: true
          },
          {
            text: 'Szybką edycję potraw bezpośrednio na jadłospisie (widok dzienny i tygodniowy)',
            tooltipText: 'Wybierz wygodny dla siebie sposób edycji diety.',
            isAvailable: true
          },
          {
            text: 'Dodawanie komentarzy do posiłków oraz komentarza tygodniowego',
            tooltipText: 'Dziel się wskazówkami i dodatkowymi zaleceniami ze swoimi pacjentami.',
            isAvailable: true
          },
          {
            text: 'Ułatwiony dostęp do historii jadłospisów pacjenta (12 miesięcy wstecz)',
            tooltipText: 'Korzystaj z dodatkowej zakładki z podsumowaniem archiwalnych jadłospisów. Pamiętaj, że cały czas masz do nich dostęp, wystarczy wejść w bieżący tydzień i użyć strzałek na kalendarzu.',
            isAvailable: true
          },
          {
            text: 'Dostęp do historii przeliczeń (do 6 miesięcy wstecz)',
            tooltipText: 'Monitoruj postępy Pacjenta na podstawie historii przeliczeń BMI, masy ciała, zapotrzebowania energetycznego (CPM, PPM), zawartości tkanki tłuszczowej.',
            isAvailable: true
          },
          {
            text: 'Dostęp do panelu ze szkoleniami',
            tooltipText: 'Zdobywaj dodatkową wiedzę dzięki szkoleniom, które możesz wykupić bezpośrednio w naszym programie.',
            isAvailable: true
          },
          {
            text: 'Profil publiczny w serwisie dla pacjentów',
            tooltipText: 'Pozyskuj pacjentów przez promowanie usług dietetycznych w serwisie dla pacjentów Kcalmar.com.',
            isAvailable: true
          },
          {
            text: 'Szczegółowy, systemowy wywiad żywieniowy',
            tooltipText: 'Uzyskaj szczegółowe informacje na temat pacjenta, dzięki szczegółowej ankiecie żywieniowej.',
            isAvailable: true
          },
          {
            text: 'Możliwość kopiowania potraw, dni i całych jadłospisów',
            tooltipText: 'Oszczędzaj czas dzięki możliwości łatwego i szybkiego kopiowania.',
            isAvailable: true
          },
          {
            text: 'Jadłospisy w formacie PDF',
            tooltipText: 'Generuj plik gotowy do wydruku lub do przekazania pacjentowi drogą elektroniczną.',
            isAvailable: true
          },
          {
            text: 'Aplikację mobilną dla pacjenta',
            tooltipText: 'Udostępnij dietę pacjentowi poprzez aplikację mobilną dostępną na systemy Android i iOS.',
            isAvailable: true
          },
          {
            text: 'Panel pacjenta na stronie internetowej',
            tooltipText: 'Dostęp pacjenta do jadłospisów na stronie internetowej po rejestracji konta.',
            isAvailable: true
          },
          {
            text: 'Automatyczną listę zakupów',
            tooltipText: 'Wygodna lista zakupów generowana na podstawie przygotowanego jadłospisu.',
            isAvailable: true
          },
          {
            text: 'Miary domowe produktów',
            tooltipText: 'Wartości wyrażone w gramach są uzupełnione o podpowiedzi dla pacjenta w postaci wygodnych miar domowych',
            isAvailable: true
          },
          {
            text: 'Możliwość ustawienia kolejności, czasu i założonego procentowego rozkładu energii posiłków',
            tooltipText: 'Twórz posiłki o zbliżonej kaloryczności dzięki procentowemu rozkładowi energii. Ustalaj pory posiłków oraz ich kolejność.',
            isAvailable: true
          },
          {
            text: 'Wyszukiwanie jadłospisów po nazwie',
            tooltipText: 'Pracuj efektywniej dzięki szybkiej wyszukiwarce jadłospisów.',
            isAvailable: true
          },
          {
            text: 'Podstawowe wartości odżywcze',
            tooltipText: 'Twórz zbilansowane jadłospisy dzięki dostępowi do kaloryczności jadłospisu, zawartości białka, tłuszczów, węglowodanów oraz błonnika.',
            isAvailable: true
          },
          {
            text: 'Duplikowanie jadłospisów (także systemowych)',
            tooltipText: 'Twórz błyskawiczne jadłospisy dzięki możliwości kopiowania gotowych jadłospisów, a następnie ich edycji.',
            isAvailable: true
          },
          {
            text: 'Porządkowanie jadłospisów w grupy',
            tooltipText: 'Uporządkuj stworzone diety w wygodne grupy.',
            isAvailable: true
          },
          {
            text: 'Możliwość przejścia na wyższy pakiet w dowolnym momencie',
            tooltipText: 'Przejdź na wyższy pakiet w dowolnym momencie. Skontaktuj się z nami w celu uzyskania szczegółowych informacji.',
            isAvailable: true
          },
          {
            text: 'Nielimitowaną liczbę jadłospisów do ułożenia',
            tooltipText: 'Twórz jadłospisy bez ograniczeń.',
            isAvailable: true
          },
          {
            text: 'Automatyczne przeliczanie wskaźników BMI, CPM, PPM, NMC oraz współczynnika PAL',
            tooltipText: 'Obliczaj zapotrzebowanie pacjenta dzięki zintegrowanym kalkulatorom.',
            isAvailable: true
          },
          {
            text: 'Nieograniczoną liczbę pacjentów',
            tooltipText: 'Buduj swoją bazę pacjentów bez ograniczeń.',
            isAvailable: true
          },
          {
            text: 'Automatyczne wyliczanie zapotrzebowania energetycznego w zależności od parametrów pacjenta',
            tooltipText: 'Twórz zbilansowane diety, które pokryją zapotrzebowanie Twojego pacjenta.',
            isAvailable: true
          },
          {
            text: 'Dostęp do 101 wskaźników i wartości odżywczych produktów oraz potraw',
            tooltipText: 'Twórz profesjonalne jadłospisy dzięki dostępowi do informacji o zawartości składników mineralnych, witamin, kwasów tłuszczowych i innych.',
            isAvailable: true
          },
          {
            text: 'Oznaczenie indeksu i ładunku glikemicznego na jadłospisie',
            tooltipText: 'Przygotuj jadłospis o niskim ładunku glikemicznym dzięki oznaczeniu IG i ŁG.',
            isAvailable: true
          },
          {
            text: 'Obliczanie wymienników węglowodanowych i białkowo-tłuszczowych',
            tooltipText: 'Przeliczaj przygotowane na jadłospisie potrawy i produkty na WW i WBT.',
            isAvailable: true
          },
          {
            text: 'Możliwość dodania własnego logo na wydruku jadłospisów',
            tooltipText: 'Promuj swoją markę dzięki spersonalizowanym wydrukom z własnym logo.',
            isAvailable: true
          },
          {
            text: 'Dodatkowe szablony graficzne wydruku z możliwością edycji',
            tooltipText: 'Wybieraj wzory graficzne jadłospisów, ukrywaj na wydruku wybrane informacje. Skorzystaj z grupowania po dniach i posiłkach a także sortowania listy zakupów.',
            isAvailable: true
          },
          {
            text: 'Zaawansowaną wyszukiwarkę produktów i potraw',
            tooltipText: 'Wyszukuj produkty i potrawy dzięki szczegółowym filtrom.',
            isAvailable: true
          },
          {
            text: 'Wizualną ocenę postępów pacjenta na wykresach',
            tooltipText: 'Monitoruj zmiany parametrów pacjenta.',
            isAvailable: true
          },
          {
            text: 'Monitorowanie realizacji norm żywienia 2024',
            tooltipText: 'Monitoruj realizację najnowszych norm żywieniowych.',
            isAvailable: true
          },
          {
            text: 'Funkcję "Cofnij/Ponów"',
            tooltipText: 'Cofnij lub ponów wprowadzone na jadłospisie zmiany jednym kliknięciem (do 5 akcji).',
            isAvailable: true
          },
          {
            text: 'Możliwość dodawania własnych pytań do wywiadu żywieniowego',
            tooltipText: 'Spersonalizuj wywiad żywieniowy dzięki możliwości dodania własnych otwartych pytań.',
            isAvailable: false
          },
          {
            text: 'Drukowanie/pobieranie ankiety żywieniowej',
            tooltipText: 'Pobierz a następnie prześlij lub wydrukuj wywiad żywieniowy dla pacjenta.',
            isAvailable: false
          },
          {
            text: 'Możliwość umawiania wizyt przez pacjentów na stronie Kcalmar.com',
            tooltipText: 'Zwiększaj liczbę pacjentów dzięki funkcji "Zapytaj o termin".',
            isAvailable: false
          },
          {
            text: 'Monitorowanie alergenów, nietolerancji oraz preferencji żywieniowych poprzez system graficznych  podpowiedzi',
            tooltipText: 'Zostań powiadomiony przez system w przypadku użycia na jadłospisie alergenów, produktów nietolerowanych oraz lubianych lub nie.',
            isAvailable: false
          },
          {
            text: 'Automatyczne skalowanie kaloryczności jadłospisów',
            tooltipText: 'Ustal nową kaloryczność skopiowanego jadłospisu a system automatycznie przeliczy zapotrzebowa  na produkty.',
            isAvailable: false
          },
          {
            text: 'Dodatkowy rozkład białek, tłuszczów i węglowodanów posiłku na widoku tygodniowym',
            tooltipText: 'Monitoruj rozkład białka, tłuszczu i węglowodanów dzięki graficznym podpowiedziom w widoku tygodniowym.',
            isAvailable: false
          },
          {
            text: 'Zamianę produktów jednym kliknięciem na całym jadłospisie',
            tooltipText: 'Błyskawicznie edytuj jadłospis dzięki możliwości podmiany składnika z poziomu listy zakupów.',
            isAvailable: false
          },
          {
            text: 'Podgląd powtarzających się potraw',
            tooltipText: 'Uatrakcyjnij swoje diety dzięki podpowiedziom o powtarzających się potrawach z ubiegłych tygodni u danego pacjenta.',
            isAvailable: false
          },
          {
            text: 'Wykorzystywanie systemowych tagów potraw i filtrowanie ich na jadłospisie',
            tooltipText: 'Wykorzystaj tagi "paleo", "potreningowy", "szybki", "fit", "z niskim IG" przy tworzeniu własnych potraw a następnie znajdź je w zaawansowanej wyszukiwarce.',
            isAvailable: false
          },
          {
            text: 'Integrację z analizatorami składu ciała',
            tooltipText: 'Wgrywaj automatycznie dane z analizatorów InBody 120 oraz 270, a także Tanita MC-580, MC-780, BC-1000, SC-240, DC-360, DC-430.',
            isAvailable: false
          },
          {
            text: 'Możliwość uwzględnienia strat talerzowych',
            tooltipText: 'Uwzględnij w diecie resztki talerzowe, kotłowe oraz odpadki kuchenne.',
            isAvailable: false
          },
          {
            text: 'Zaawansowane wyszukiwanie posiłków dla diet wegańskich, wegetariańskich, bezglutenowych i bezmlecznych',
            tooltipText: 'Dostosuj szybko dietę do specjalnych preferencji pacjenta.',
            isAvailable: false
          },
          {
            text: 'Możliwość edycji norm żywienia 2024',
            tooltipText: 'Możliwość personalizacji norm dla danego pacjenta.',
            isAvailable: false
          },
          {
            text: 'Możliwość ukrycia logo Kcalmar.pro oraz informacji o aplikacji mobilnej z wydruku',
            tooltipText: 'Generuj spersonalizowane wydruki pdf dzięki opcji ukrycia informacji o możliwości odbioru diety poprzez aplikację mobilną Kcalmar - Pacjent.',
            isAvailable: false
          },
          {
            text: 'Możliwość udostępniania jadłospisów innym dietetykom',
            tooltipText: 'Przekaż gotowy jadłospis wybranemu dietetykowi posiadającemu konto w programie Kcalmar.pro.',
            isAvailable: false
          },
          {
            text: 'Dostęp do certyfikowanych szkoleń Kcalmar.pro, które odbędą się w czasie trwania planu',
            tooltipText: 'Obejmuje wszystkie szkolenia z cyklu IEŻ, które odbędą się w trakcie trwania Twojego planu.',
            isAvailable: false
          },
          {
            text: 'Możliwość publikacji artykułów na blogu Kcalmar.com dla pacjentów',
            tooltipText: 'Publikuj artykuły na blogu Kcalmar.com, aby dotrzeć do większej liczby pacjentów.',
            isAvailable: false
          },
          {
            text: 'Promowanie profilu w wyszukiwarce dietetyków',
            tooltipText: 'Wyróżnij się w wyszukiwarce dietetyków Kcalmar dla pacjentów.',
            isAvailable: false
          },
          {
            text: 'Dodatkowe zniżki i specjalne oferty',
            tooltipText: 'Skorzystaj z preferencyjnych rabatów na oferty Kcalmar.pro i IEŻ.',
            isAvailable: false
          },
          {
            text: 'Twojego osobistego doradcę',
            tooltipText: 'Rozwiązuj problemy z pomocą konsultanta.',
            isAvailable: false
          }
        ],
        'Premium': [
          {
            text: 'Błyskawiczny kreator jadłospisów',
            tooltipText: 'Twórz jadłospisy w prosty i efektywny sposób dzięki naszemu nowoczesnemu narzędziu.',
            isAvailable: true
          },
          {
            text: 'Dostęp do pełnej bazy produktów IŻŻ',
            tooltipText: 'Bogata baza produktów IŻŻ uzupełniona o produkty z bazy USDA, UK, NCCDB, bazy Szwajcarskiej, z możliwością rozbudowy prywatnej bazy produktów.',
            isAvailable: true
          },
          {
            text: 'Możliwość dodawania własnych produktów i potraw',
            tooltipText: 'Ponad 1100 potraw systemowych. Maksymalny limit dla poszczególnych pakietów określony powyżej',
            isAvailable: true
          },
          {
            text: 'Możliwość komponowania potraw wieloporcjowych wraz z informacją o niewykorzystanych porcjach',
            tooltipText: 'Umieszczaj w diecie dania, które możesz podzielić na kilka porcji a następnie wykorzystać je w kolejnych dniach.',
            isAvailable: true
          },
          {
            text: 'Szybką edycję potraw bezpośrednio na jadłospisie (widok dzienny i tygodniowy)',
            tooltipText: 'Wybierz wygodny dla siebie sposób edycji diety.',
            isAvailable: true
          },
          {
            text: 'Dodawanie komentarzy do posiłków oraz komentarza tygodniowego',
            tooltipText: 'Dziel się wskazówkami i dodatkowymi zaleceniami ze swoimi pacjentami.',
            isAvailable: true
          },
          {
            text: 'Ułatwiony dostęp do historii jadłospisów pacjenta (bez limitu czasowego)',
            tooltipText: 'Korzystaj z dodatkowej zakładki z podsumowaniem archiwalnych jadłospisów. Pamiętaj, że cały czas masz do nich dostęp, wystarczy wejść w bieżący tydzień i użyć strzałek na kalendarzu.',
            isAvailable: true
          },
          {
            text: 'Dostęp do historii przeliczeń (do 12 miesięcy wstecz)',
            tooltipText: 'Monitoruj postępy Pacjenta na podstawie historii przeliczeń BMI, masy ciała, zapotrzebowania energetycznego (CPM, PPM), zawartości tkanki tłuszczowej.',
            isAvailable: true
          },
          {
            text: 'Dostęp do panelu ze szkoleniami',
            tooltipText: 'Zdobywaj dodatkową wiedzę dzięki szkoleniom, które możesz wykupić bezpośrednio w naszym programie.',
            isAvailable: true
          },
          {
            text: 'Profil publiczny w serwisie dla pacjentów',
            tooltipText: 'Pozyskuj pacjentów przez promowanie usług dietetycznych w serwisie dla pacjentów Kcalmar.com.',
            isAvailable: true
          },
          {
            text: 'Szczegółowy, systemowy wywiad żywieniowy',
            tooltipText: 'Uzyskaj szczegółowe informacje na temat pacjenta, dzięki szczegółowej ankiecie żywieniowej.',
            isAvailable: true
          },
          {
            text: 'Możliwość kopiowania potraw, dni i całych jadłospisów',
            tooltipText: 'Oszczędzaj czas dzięki możliwości łatwego i szybkiego kopiowania.',
            isAvailable: true
          },
          {
            text: 'Jadłospisy w formacie PDF',
            tooltipText: 'Generuj plik gotowy do wydruku lub do przekazania pacjentowi drogą elektroniczną.',
            isAvailable: true
          },
          {
            text: 'Aplikację mobilną dla pacjenta',
            tooltipText: 'Udostępnij dietę pacjentowi poprzez aplikację mobilną dostępną na systemy Android i iOS.',
            isAvailable: true
          },
          {
            text: 'Panel pacjenta na stronie internetowej',
            tooltipText: 'Dostęp pacjenta do jadłospisów na stronie internetowej po rejestracji konta.',
            isAvailable: true
          },
          {
            text: 'Automatyczną listę zakupów',
            tooltipText: 'Wygodna lista zakupów generowana na podstawie przygotowanego jadłospisu.',
            isAvailable: true
          },
          {
            text: 'Miary domowe produktów',
            tooltipText: 'Wartości wyrażone w gramach są uzupełnione o podpowiedzi dla pacjenta w postaci wygodnych miar domowych',
            isAvailable: true
          },
          {
            text: 'Możliwość ustawienia kolejności, czasu i założonego procentowego rozkładu energii posiłków',
            tooltipText: 'Twórz posiłki o zbliżonej kaloryczności dzięki procentowemu rozkładowi energii. Ustalaj pory posiłków oraz ich kolejność.',
            isAvailable: true
          },
          {
            text: 'Wyszukiwanie jadłospisów po nazwie',
            tooltipText: 'Pracuj efektywniej dzięki szybkiej wyszukiwarce jadłospisów.',
            isAvailable: true
          },
          {
            text: 'Podstawowe wartości odżywcze',
            tooltipText: 'Twórz zbilansowane jadłospisy dzięki dostępowi do kaloryczności jadłospisu, zawartości białka, tłuszczów, węglowodanów oraz błonnika.',
            isAvailable: true
          },
          {
            text: 'Duplikowanie jadłospisów (także systemowych)',
            tooltipText: 'Twórz błyskawiczne jadłospisy dzięki możliwości kopiowania gotowych jadłospisów, a następnie ich edycji.',
            isAvailable: true
          },
          {
            text: 'Porządkowanie jadłospisów w grupy',
            tooltipText: 'Uporządkuj stworzone diety w wygodne grupy.',
            isAvailable: true
          },
          {
            text: 'Możliwość przejścia na wyższy pakiet w dowolnym momencie',
            tooltipText: 'Przejdź na wyższy pakiet w dowolnym momencie. Skontaktuj się z nami w celu uzyskania szczegółowych informacji.',
            isAvailable: true
          },
          {
            text: 'Nielimitowaną liczbę jadłospisów do ułożenia',
            tooltipText: 'Twórz jadłospisy bez ograniczeń.',
            isAvailable: true
          },
          {
            text: 'Automatyczne przeliczanie wskaźników BMI, CPM, PPM, NMC oraz współczynnika PAL',
            tooltipText: 'Obliczaj zapotrzebowanie pacjenta dzięki zintegrowanym kalkulatorom.',
            isAvailable: true
          },
          {
            text: 'Nieograniczoną liczbę pacjentów',
            tooltipText: 'Buduj swoją bazę pacjentów bez ograniczeń.',
            isAvailable: true
          },
          {
            text: 'Automatyczne wyliczanie zapotrzebowania energetycznego w zależności od parametrów pacjenta',
            tooltipText: 'Twórz zbilansowane diety, które pokryją zapotrzebowanie Twojego pacjenta.',
            isAvailable: true
          },
          {
            text: 'Dostęp do 101 wskaźników i wartości odżywczych produktów oraz potraw',
            tooltipText: 'Twórz profesjonalne jadłospisy dzięki dostępowi do informacji o zawartości składników mineralnych, witamin, kwasów tłuszczowych i innych.',
            isAvailable: true
          },
          {
            text: 'Oznaczenie indeksu i ładunku glikemicznego na jadłospisie',
            tooltipText: 'Przygotuj jadłospis o niskim ładunku glikemicznym dzięki oznaczeniu IG i ŁG.',
            isAvailable: true
          },
          {
            text: 'Obliczanie wymienników węglowodanowych i białkowo-tłuszczowych',
            tooltipText: 'Przeliczaj przygotowane na jadłospisie potrawy i produkty na WW i WBT.',
            isAvailable: true
          },
          {
            text: 'Możliwość dodania własnego logo na wydruku jadłospisów',
            tooltipText: 'Promuj swoją markę dzięki spersonalizowanym wydrukom z własnym logo.',
            isAvailable: true
          },
          {
            text: 'Dodatkowe szablony graficzne wydruku z możliwością edycji',
            tooltipText: 'Wybieraj wzory graficzne jadłospisów, ukrywaj na wydruku wybrane informacje. Skorzystaj z grupowania po dniach i posiłkach a także sortowania listy zakupów.',
            isAvailable: true
          },
          {
            text: 'Zaawansowaną wyszukiwarkę produktów i potraw',
            tooltipText: 'Wyszukuj produkty i potrawy dzięki szczegółowym filtrom.',
            isAvailable: true
          },
          {
            text: 'Wizualną ocenę postępów pacjenta na wykresach',
            tooltipText: 'Monitoruj zmiany parametrów pacjenta.',
            isAvailable: true
          },
          {
            text: 'Monitorowanie realizacji norm żywienia 2024',
            tooltipText: 'Monitoruj realizację najnowszych norm żywieniowych.',
            isAvailable: true
          },
          {
            text: 'Funkcję "Cofnij/Ponów"',
            tooltipText: 'Cofnij lub ponów wprowadzone na jadłospisie zmiany jednym kliknięciem (do 5 akcji).',
            isAvailable: true
          },
          {
            text: 'Możliwość dodawania własnych pytań do wywiadu żywieniowego',
            tooltipText: 'Spersonalizuj wywiad żywieniowy dzięki możliwości dodania własnych otwartych pytań.',
            isAvailable: true
          },
          {
            text: 'Drukowanie/pobieranie ankiety żywieniowej',
            tooltipText: 'Pobierz a następnie prześlij lub wydrukuj wywiad żywieniowy dla pacjenta.',
            isAvailable: true
          },
          {
            text: 'Możliwość umawiania wizyt przez pacjentów na stronie Kcalmar.com',
            tooltipText: 'Zwiększaj liczbę pacjentów dzięki funkcji "Zapytaj o termin".',
            isAvailable: true
          },
          {
            text: 'Monitorowanie alergenów, nietolerancji oraz preferencji żywieniowych poprzez system graficznych  podpowiedzi',
            tooltipText: 'Zostań powiadomiony przez system w przypadku użycia na jadłospisie alergenów, produktów nietolerowanych oraz lubianych lub nie.',
            isAvailable: true
          },
          {
            text: 'Automatyczne skalowanie kaloryczności jadłospisów',
            tooltipText: 'Ustal nową kaloryczność skopiowanego jadłospisu a system automatycznie przeliczy zapotrzebowa  na produkty.',
            isAvailable: true
          },
          {
            text: 'Dodatkowy rozkład białek, tłuszczów i węglowodanów posiłku na widoku tygodniowym',
            tooltipText: 'Monitoruj rozkład białka, tłuszczu i węglowodanów dzięki graficznym podpowiedziom w widoku tygodniowym.',
            isAvailable: true
          },
          {
            text: 'Zamianę produktów jednym kliknięciem na całym jadłospisie',
            tooltipText: 'Błyskawicznie edytuj jadłospis dzięki możliwości podmiany składnika z poziomu listy zakupów.',
            isAvailable: true
          },
          {
            text: 'Podgląd powtarzających się potraw',
            tooltipText: 'Uatrakcyjnij swoje diety dzięki podpowiedziom o powtarzających się potrawach z ubiegłych tygodni u danego pacjenta.',
            isAvailable: true
          },
          {
            text: 'Wykorzystywanie systemowych tagów potraw i filtrowanie ich na jadłospisie',
            tooltipText: 'Wykorzystaj tagi "paleo", "potreningowy", "szybki", "fit", "z niskim IG" przy tworzeniu własnych potraw a następnie znajdź je w zaawansowanej wyszukiwarce.',
            isAvailable: true
          },
          {
            text: 'Integrację z analizatorami składu ciała',
            tooltipText: 'Wgrywaj automatycznie dane z analizatorów InBody 120 oraz 270, a także Tanita MC-580, MC-780, BC-1000, SC-240, DC-360, DC-430.',
            isAvailable: true
          },
          {
            text: 'Możliwość uwzględnienia strat talerzowych',
            tooltipText: 'Uwzględnij w diecie resztki talerzowe, kotłowe oraz odpadki kuchenne.',
            isAvailable: true
          },
          {
            text: 'Zaawansowane wyszukiwanie posiłków dla diet wegańskich, wegetariańskich, bezglutenowych i bezmlecznych',
            tooltipText: 'Dostosuj szybko dietę do specjalnych preferencji pacjenta.',
            isAvailable: true
          },
          {
            text: 'Możliwość edycji norm żywienia 2024',
            tooltipText: 'Możliwość personalizacji norm dla danego pacjenta.',
            isAvailable: true
          },
          {
            text: 'Możliwość ukrycia logo Kcalmar.pro oraz informacji o aplikacji mobilnej z wydruku',
            tooltipText: 'Generuj spersonalizowane wydruki pdf dzięki opcji ukrycia informacji o możliwości odbioru diety poprzez aplikację mobilną Kcalmar - Pacjent.',
            isAvailable: true
          },
          {
            text: 'Możliwość udostępniania jadłospisów innym dietetykom',
            tooltipText: 'Przekaż gotowy jadłospis wybranemu dietetykowi posiadającemu konto w programie Kcalmar.pro.',
            isAvailable: false
          },
          {
            text: 'Dostęp do certyfikowanych szkoleń Kcalmar.pro, które odbędą się w czasie trwania planu',
            tooltipText: 'Obejmuje wszystkie szkolenia z cyklu IEŻ, które odbędą się w trakcie trwania Twojego planu.',
            isAvailable: false
          },
          {
            text: 'Możliwość publikacji artykułów na blogu Kcalmar.com dla pacjentów',
            tooltipText: 'Publikuj artykuły na blogu Kcalmar.com, aby dotrzeć do większej liczby pacjentów.',
            isAvailable: false
          },
          {
            text: 'Promowanie profilu w wyszukiwarce dietetyków',
            tooltipText: 'Wyróżnij się w wyszukiwarce dietetyków Kcalmar dla pacjentów.',
            isAvailable: false
          },
          {
            text: 'Dodatkowe zniżki i specjalne oferty',
            tooltipText: 'Skorzystaj z preferencyjnych rabatów na oferty Kcalmar.pro i IEŻ.',
            isAvailable: false
          },
          {
            text: 'Twojego osobistego doradcę',
            tooltipText: 'Rozwiązuj problemy z pomocą konsultanta.',
            isAvailable: false
          }
        ],
        'VIP': [
          {
            text: 'Błyskawiczny kreator jadłospisów',
            tooltipText: 'Twórz jadłospisy w prosty i efektywny sposób dzięki naszemu nowoczesnemu narzędziu.',
            isAvailable: true
          },
          {
            text: 'Dostęp do pełnej bazy produktów IŻŻ',
            tooltipText: 'Bogata baza produktów IŻŻ uzupełniona o produkty z bazy USDA, UK, NCCDB, bazy Szwajcarskiej, z możliwością rozbudowy prywatnej bazy produktów.',
            isAvailable: true
          },
          {
            text: 'Możliwość dodawania własnych produktów i potraw',
            tooltipText: 'Ponad 1100 potraw systemowych. Maksymalny limit dla poszczególnych pakietów określony powyżej',
            isAvailable: true
          },
          {
            text: 'Możliwość komponowania potraw wieloporcjowych wraz z informacją o niewykorzystanych porcjach',
            tooltipText: 'Umieszczaj w diecie dania, które możesz podzielić na kilka porcji a następnie wykorzystać je w kolejnych dniach.',
            isAvailable: true
          },
          {
            text: 'Szybką edycję potraw bezpośrednio na jadłospisie (widok dzienny i tygodniowy)',
            tooltipText: 'Wybierz wygodny dla siebie sposób edycji diety.',
            isAvailable: true
          },
          {
            text: 'Dodawanie komentarzy do posiłków oraz komentarza tygodniowego',
            tooltipText: 'Dziel się wskazówkami i dodatkowymi zaleceniami ze swoimi pacjentami.',
            isAvailable: true
          },
          {
            text: 'Ułatwiony dostęp do historii jadłospisów pacjenta (bez limitu czasowego)',
            tooltipText: 'Korzystaj z dodatkowej zakładki z podsumowaniem archiwalnych jadłospisów. Pamiętaj, że cały czas masz do nich dostęp, wystarczy wejść w bieżący tydzień i użyć strzałek na kalendarzu.',
            isAvailable: true
          },
          {
            text: 'Dostęp do historii przeliczeń (bez ograniczeń)',
            tooltipText: 'Monitoruj postępy Pacjenta na podstawie historii przeliczeń BMI, masy ciała, zapotrzebowania energetycznego (CPM, PPM), zawartości tkanki tłuszczowej.',
            isAvailable: true
          },
          {
            text: 'Dostęp do panelu ze szkoleniami',
            tooltipText: 'Zdobywaj dodatkową wiedzę dzięki szkoleniom, które możesz wykupić bezpośrednio w naszym programie.',
            isAvailable: true
          },
          {
            text: 'Profil publiczny w serwisie dla pacjentów',
            tooltipText: 'Pozyskuj pacjentów przez promowanie usług dietetycznych w serwisie dla pacjentów Kcalmar.com.',
            isAvailable: true
          },
          {
            text: 'Szczegółowy, systemowy wywiad żywieniowy',
            tooltipText: 'Uzyskaj szczegółowe informacje na temat pacjenta, dzięki szczegółowej ankiecie żywieniowej.',
            isAvailable: true
          },
          {
            text: 'Możliwość kopiowania potraw, dni i całych jadłospisów',
            tooltipText: 'Oszczędzaj czas dzięki możliwości łatwego i szybkiego kopiowania.',
            isAvailable: true
          },
          {
            text: 'Jadłospisy w formacie PDF',
            tooltipText: 'Generuj plik gotowy do wydruku lub do przekazania pacjentowi drogą elektroniczną.',
            isAvailable: true
          },
          {
            text: 'Aplikację mobilną dla pacjenta',
            tooltipText: 'Udostępnij dietę pacjentowi poprzez aplikację mobilną dostępną na systemy Android i iOS.',
            isAvailable: true
          },
          {
            text: 'Panel pacjenta na stronie internetowej',
            tooltipText: 'Dostęp pacjenta do jadłospisów na stronie internetowej po rejestracji konta.',
            isAvailable: true
          },
          {
            text: 'Automatyczną listę zakupów',
            tooltipText: 'Wygodna lista zakupów generowana na podstawie przygotowanego jadłospisu.',
            isAvailable: true
          },
          {
            text: 'Miary domowe produktów',
            tooltipText: 'Wartości wyrażone w gramach są uzupełnione o podpowiedzi dla pacjenta w postaci wygodnych miar domowych',
            isAvailable: true
          },
          {
            text: 'Możliwość ustawienia kolejności, czasu i założonego procentowego rozkładu energii posiłków',
            tooltipText: 'Twórz posiłki o zbliżonej kaloryczności dzięki procentowemu rozkładowi energii. Ustalaj pory posiłków oraz ich kolejność.',
            isAvailable: true
          },
          {
            text: 'Wyszukiwanie jadłospisów po nazwie',
            tooltipText: 'Pracuj efektywniej dzięki szybkiej wyszukiwarce jadłospisów.',
            isAvailable: true
          },
          {
            text: 'Podstawowe wartości odżywcze',
            tooltipText: 'Twórz zbilansowane jadłospisy dzięki dostępowi do kaloryczności jadłospisu, zawartości białka, tłuszczów, węglowodanów oraz błonnika.',
            isAvailable: true
          },
          {
            text: 'Duplikowanie jadłospisów (także systemowych)',
            tooltipText: 'Twórz błyskawiczne jadłospisy dzięki możliwości kopiowania gotowych jadłospisów, a następnie ich edycji.',
            isAvailable: true
          },
          {
            text: 'Porządkowanie jadłospisów w grupy',
            tooltipText: 'Uporządkuj stworzone diety w wygodne grupy.',
            isAvailable: true
          },
          {
            text: 'Możliwość przejścia na wyższy pakiet w dowolnym momencie',
            tooltipText: 'Przejdź na wyższy pakiet w dowolnym momencie. Skontaktuj się z nami w celu uzyskania szczegółowych informacji.',
            isAvailable: true
          },
          {
            text: 'Nielimitowaną liczbę jadłospisów do ułożenia',
            tooltipText: 'Twórz jadłospisy bez ograniczeń.',
            isAvailable: true
          },
          {
            text: 'Automatyczne przeliczanie wskaźników BMI, CPM, PPM, NMC oraz współczynnika PAL',
            tooltipText: 'Obliczaj zapotrzebowanie pacjenta dzięki zintegrowanym kalkulatorom.',
            isAvailable: true
          },
          {
            text: 'Nieograniczoną liczbę pacjentów',
            tooltipText: 'Buduj swoją bazę pacjentów bez ograniczeń.',
            isAvailable: true
          },
          {
            text: 'Automatyczne wyliczanie zapotrzebowania energetycznego w zależności od parametrów pacjenta',
            tooltipText: 'Twórz zbilansowane diety, które pokryją zapotrzebowanie Twojego pacjenta.',
            isAvailable: true
          },
          {
            text: 'Dostęp do 101 wskaźników i wartości odżywczych produktów oraz potraw',
            tooltipText: 'Twórz profesjonalne jadłospisy dzięki dostępowi do informacji o zawartości składników mineralnych, witamin, kwasów tłuszczowych i innych.',
            isAvailable: true
          },
          {
            text: 'Oznaczenie indeksu i ładunku glikemicznego na jadłospisie',
            tooltipText: 'Przygotuj jadłospis o niskim ładunku glikemicznym dzięki oznaczeniu IG i ŁG.',
            isAvailable: true
          },
          {
            text: 'Obliczanie wymienników węglowodanowych i białkowo-tłuszczowych',
            tooltipText: 'Przeliczaj przygotowane na jadłospisie potrawy i produkty na WW i WBT.',
            isAvailable: true
          },
          {
            text: 'Możliwość dodania własnego logo na wydruku jadłospisów',
            tooltipText: 'Promuj swoją markę dzięki spersonalizowanym wydrukom z własnym logo.',
            isAvailable: true
          },
          {
            text: 'Dodatkowe szablony graficzne wydruku z możliwością edycji',
            tooltipText: 'Wybieraj wzory graficzne jadłospisów, ukrywaj na wydruku wybrane informacje. Skorzystaj z grupowania po dniach i posiłkach a także sortowania listy zakupów.',
            isAvailable: true
          },
          {
            text: 'Zaawansowaną wyszukiwarkę produktów i potraw',
            tooltipText: 'Wyszukuj produkty i potrawy dzięki szczegółowym filtrom.',
            isAvailable: true
          },
          {
            text: 'Wizualną ocenę postępów pacjenta na wykresach',
            tooltipText: 'Monitoruj zmiany parametrów pacjenta.',
            isAvailable: true
          },
          {
            text: 'Monitorowanie realizacji norm żywienia 2024',
            tooltipText: 'Monitoruj realizację najnowszych norm żywieniowych.',
            isAvailable: true
          },
          {
            text: 'Funkcję "Cofnij/Ponów"',
            tooltipText: 'Cofnij lub ponów wprowadzone na jadłospisie zmiany jednym kliknięciem (do 5 akcji).',
            isAvailable: true
          },
          {
            text: 'Możliwość dodawania własnych pytań do wywiadu żywieniowego',
            tooltipText: 'Spersonalizuj wywiad żywieniowy dzięki możliwości dodania własnych otwartych pytań.',
            isAvailable: true
          },
          {
            text: 'Drukowanie/pobieranie ankiety żywieniowej',
            tooltipText: 'Pobierz a następnie prześlij lub wydrukuj wywiad żywieniowy dla pacjenta.',
            isAvailable: true
          },
          {
            text: 'Możliwość umawiania wizyt przez pacjentów na stronie Kcalmar.com',
            tooltipText: 'Zwiększaj liczbę pacjentów dzięki funkcji "Zapytaj o termin".',
            isAvailable: true
          },
          {
            text: 'Monitorowanie alergenów, nietolerancji oraz preferencji żywieniowych poprzez system graficznych  podpowiedzi',
            tooltipText: 'Zostań powiadomiony przez system w przypadku użycia na jadłospisie alergenów, produktów nietolerowanych oraz lubianych lub nie.',
            isAvailable: true
          },
          {
            text: 'Automatyczne skalowanie kaloryczności jadłospisów',
            tooltipText: 'Ustal nową kaloryczność skopiowanego jadłospisu a system automatycznie przeliczy zapotrzebowa  na produkty.',
            isAvailable: true
          },
          {
            text: 'Dodatkowy rozkład białek, tłuszczów i węglowodanów posiłku na widoku tygodniowym',
            tooltipText: 'Monitoruj rozkład białka, tłuszczu i węglowodanów dzięki graficznym podpowiedziom w widoku tygodniowym.',
            isAvailable: true
          },
          {
            text: 'Zamianę produktów jednym kliknięciem na całym jadłospisie',
            tooltipText: 'Błyskawicznie edytuj jadłospis dzięki możliwości podmiany składnika z poziomu listy zakupów.',
            isAvailable: true
          },
          {
            text: 'Podgląd powtarzających się potraw',
            tooltipText: 'Uatrakcyjnij swoje diety dzięki podpowiedziom o powtarzających się potrawach z ubiegłych tygodni u danego pacjenta.',
            isAvailable: true
          },
          {
            text: 'Wykorzystywanie systemowych tagów potraw i filtrowanie ich na jadłospisie',
            tooltipText: 'Wykorzystaj tagi "paleo", "potreningowy", "szybki", "fit", "z niskim IG" przy tworzeniu własnych potraw a następnie znajdź je w zaawansowanej wyszukiwarce.',
            isAvailable: true
          },
          {
            text: 'Integrację z analizatorami składu ciała',
            tooltipText: 'Wgrywaj automatycznie dane z analizatorów InBody 120 oraz 270, a także Tanita MC-580, MC-780, BC-1000, SC-240, DC-360, DC-430.',
            isAvailable: true
          },
          {
            text: 'Możliwość uwzględnienia strat talerzowych',
            tooltipText: 'Uwzględnij w diecie resztki talerzowe, kotłowe oraz odpadki kuchenne.',
            isAvailable: true
          },
          {
            text: 'Zaawansowane wyszukiwanie posiłków dla diet wegańskich, wegetariańskich, bezglutenowych i bezmlecznych',
            tooltipText: 'Dostosuj szybko dietę do specjalnych preferencji pacjenta.',
            isAvailable: true
          },
          {
            text: 'Możliwość edycji norm żywienia 2024',
            tooltipText: 'Możliwość personalizacji norm dla danego pacjenta.',
            isAvailable: true
          },
          {
            text: 'Możliwość ukrycia logo Kcalmar.pro oraz informacji o aplikacji mobilnej z wydruku',
            tooltipText: 'Generuj spersonalizowane wydruki pdf dzięki opcji ukrycia informacji o możliwości odbioru diety poprzez aplikację mobilną Kcalmar - Pacjent.',
            isAvailable: true
          },
          {
            text: 'Możliwość udostępniania jadłospisów innym dietetykom',
            tooltipText: 'Przekaż gotowy jadłospis wybranemu dietetykowi posiadającemu konto w programie Kcalmar.pro.',
            isAvailable: true
          },
          {
            text: 'Dostęp do certyfikowanych szkoleń Kcalmar.pro, które odbędą się w czasie trwania planu',
            tooltipText: 'Obejmuje wszystkie szkolenia z cyklu IEŻ, które odbędą się w trakcie trwania Twojego planu.',
            isAvailable: true
          },
          {
            text: 'Możliwość publikacji artykułów na blogu Kcalmar.com dla pacjentów',
            tooltipText: 'Publikuj artykuły na blogu Kcalmar.com, aby dotrzeć do większej liczby pacjentów.',
            isAvailable: true
          },
          {
            text: 'Promowanie profilu w wyszukiwarce dietetyków',
            tooltipText: 'Wyróżnij się w wyszukiwarce dietetyków Kcalmar dla pacjentów.',
            isAvailable: true
          },
          {
            text: 'Dodatkowe zniżki i specjalne oferty',
            tooltipText: 'Skorzystaj z preferencyjnych rabatów na oferty Kcalmar.pro i IEŻ.',
            isAvailable: true
          },
          {
            text: 'Twojego osobistego doradcę',
            tooltipText: 'Rozwiązuj problemy z pomocą konsultanta.',
            isAvailable: true
          }
        ]
      }
    }
  }
}
</script>

<style scoped>
.step-one-content{
  overflow: visible;
  width: 100%;
  margin-top: 80px;
}
.step-one-content .step-title-container{
  position: relative;
  margin-bottom: 90px;
}
.more-info a{
  text-decoration: underline;
  color: #41CDA8;
  font-family: 'Roboto-Regular';
  font-weight: 700;
}
.row .col-content{
  padding: 6px;
}
.plans-wrapper{
  display: block;
  position: relative;
}
.plan-line{
  width: calc(75%);
  max-width: calc(75%);
  background-color: #F5F5F5;
  height: 10px;
  position: absolute;
  z-index: 2;
  top: 115px;
  border-radius: 20px;
  transform: translateX(-50%);
  left: 50%;
  z-index: 100;
}
.global-discount-is-active .plan-line{
  top: 145px;
}
.plan-line:after{
  content: '';
  position: absolute;
  width: 0%;
  background-color: #41CDA8;
  border-radius: 25px;
  height: 100%;
  transition: all 0.3s ease-in-out;
}
.plan-line.l1:after{
  width: calc(100% / 3);
}
.plan-line.l2:after{
  width: calc(100% * 2 / 3);
}
.plan-line.l3:after{
  width: 100%;
}
.plan-point{
  width: 20px;
  height: 20px;
  background-color: #F5F5F5;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  border-radius: 20px;
  transition: all 0.5s ease-in-out;
}
.plan-point.active{
  background-color: #41CDA8;
}
.plan-point:nth-child(1){
  left: 0%;
}
.plan-point:nth-child(2){
  left: calc(100% / 3 - 10px);
}
.plan-point:nth-child(3){
  left: calc(200% / 3 - 10px);
}
.plan-point:nth-child(4){
  left: calc(100% - 10px);
}
.plans-carousel{
  display: flex;
}
.plan{
  color: black;
  background-color: #E6E6E6;
  position: relative;
  cursor: pointer;
  flex-basis: 25%;
  transition: all 0.3s ease-in-out;
}
.plan:hover{
  background-color: #dddddd;
}
.plan-label{
  position: absolute;
  color: #FFFFFF;
  font-size: 13px;
  font-weight: 600;
  font-family: 'Roboto-Medium';
  background-color: #41CDA8;
  text-transform: uppercase;
  padding: 13px 0;
  width: 100%;
  text-align: center;
  top: -39px;
  border-radius: 5px 5px 0 0;
}
.vip-plan-label{
  position: absolute;
  color: #FFFFFF;
  font-size: 13px;
  font-weight: 600;
  font-family: 'Roboto-Medium';
  background-color: #E90855;
  text-transform: uppercase;
  padding-top: 14px;
  padding-bottom: 13px;
  width: 100%;
  text-align: center;
  top: -80px;
  border-radius: 5px 5px 0 0;
}
.vip-plan-label hr{
  height: 1px;
  border: 0;
  background-color: #b70a45;
  margin-bottom: 12px;
  margin-top: 13px;
}
.plan.active{
  background-color: #FFFFFF;
  box-shadow: 0 0 20px 0 #a9a9a9;
  z-index: 1;
}
.plan.disabled{
  background-color: #ececec;
  color: #999999;
  box-shadow: none;
  pointer-events: all;
  /* position: relative; */
}
.plan.disabled > *{
  pointer-events: none;
}
.plan-content{
  padding-top: 15px;
  border: 1px solid #FFFFFF;
  border-top: 0;
  border-bottom: 0;
  display: flex;
  flex-direction: column;
}
.plan-name{
  font-size: 19px;
  font-weight: 500;
  text-align: center;
  font-family: 'Roboto-Regular';
  margin-bottom: 15px;
}
.stars:first-of-type{
  padding-right: 7px;
}
.stars:last-of-type{
  padding-left: 7px;
}
.price-wrapper{
  margin: auto;
}
.price-with-out-discount-label{
  padding: 5px 0;
}
.price{
  margin-bottom: 15px;
}
.price-prefix{
  font-size: 10px;
  vertical-align: text-top;
}
.price-integer{
  font-size: 40px;
  font-family: 'Roboto-Regular';
  font-weight: 700;
  padding: 0px 4px;
}
.price-decimal-places{
  font-size: 14px;
  font-family: 'Roboto-Regular';
  font-weight: 700;
  line-height: 18px;
}
.price-sufix{
  font-size: 10px;
  display: inline-block;
}
.discount-label{
  font-size: 12px;
  color: #999;
  background-color: #fff;
  text-align: center;
  padding: 10px;
  display: inline-block;
  margin: auto;
  border-radius: 22px;
  margin-bottom: 25px;
  border: 1px solid #e6e6e6;
}
.discount-label span{
  color: #E90855;
  font-weight: 700;
}
.discount-label-spacer{
  height: 32px;
  margin-bottom: 28px;
}
.plan-property{
  font-size: 11px;
  padding: 20px;
  padding-left: 40px;
  background-image: url(../../assets/img/common/check_grey.svg);
  background-repeat: no-repeat;
  background-position: 18px center;
  background-size: 20px;
  border-top: 1px solid white;
}
.active .plan-property{
  border-top: 1px solid #e5e5e5;
  background-image: url(../../assets/img/common/check_green.svg);
}
.plan-property--first,
.active .plan-property--first{
  border-top: 1px solid transparent;
}
.dots-navigation{
  display: none;
}
.price-info{
  font-size: 12px;
  padding-right: 5px;
  padding-top: 10px;
  color: #999;
}
.big-plan-name{
  color: #000;
  font-family: 'Roboto-Regular';
  font-size: 35px;
  margin-top: 0;
  font-weight: 700;
  padding-bottom: 20px;
}
.plan-description{
  font-size: 15px;
  font-family: 'Roboto-Regular';
  font-weight: 400;
}
.grey-label{
  text-transform: uppercase;
  color: #999;
  font-family: 'Roboto-Medium';
  font-weight: 700;
}
.plan-details{
  padding: 30px 20px;
  margin-top: 50px;
  border: 1px solid;
  border: 2px dashed #E6E6E6;
}
.plan-details.active{
  /* display: block */
}
.plan-details p{
  /* margin: 10px 0; */
}
.detail-features{
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  font-size: 17px;
  font-family: 'Roboto-Medium';
  padding: 15px 0px;
}
.detail-feature span:nth-child(1){
  color: #E90855;
}
.detail-feature{
  padding: 20px 0;
  padding-left: 45px;
  background-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiP…AgICA8L2c+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg==);
  background-position: 0px center;
  background-size: 40px;
  letter-spacing: -0.5px;
  background-repeat: no-repeat;
}
.detail-feature:nth-child(1){
  background-image: url(../../assets/img/common/icon_menu.svg);
}
.detail-feature:nth-child(2){
  background-image: url(../../assets/img/common/icon_dish.svg);
}
.detail-feature:nth-child(3){
  background-image: url(../../assets/img/common/icon_system_menu.svg);
}
.plan-features {
  list-style-type: none;
  padding: 0;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  height: 1400px;
}
.plan-features li{
  padding: 15px 0;
  padding-left: 28px;
  padding-right: 15px;
  background-position: left center;
  background-size: 21px;
  background-repeat: no-repeat;
  position: relative;
  max-width: 585px;
}
.plan-features li.available{
  background-image: url(../../assets/img/common/available_check.svg);
}
.plan-features li.unavailable{
  background-image: url(../../assets/img/common/unavailable_check.svg);
}
.plan-features li.has-tooltip{
  /*text-decoration: underline;*/
}
.plan-details .row:nth-child(5){
  margin-top: 30px;
}
.col-plan-properties{
  max-width: calc(100% / 3);
  flex: 1 0 calc(100% / 3);
}
.row .more-info{
  max-width: calc(100% - 2 * 15px);
  flex: 1 0 calc(100% - 2 * 15px);
  text-align: center;
  margin-top: 22px;
  margin-bottom: 30px;
  padding: 15px;
  border: 2px solid #48daa9;
  border-radius: 5px;
}
.button-wrapper{
  justify-content: flex-end;
}
.tooltip {
  z-index: 1000;
}
.list-plan-details {
  margin-bottom: 20px;
}
@media screen and (max-width: 1600px) {
  .plan-features li {
    max-width: 450px;
  }
  .plan-features {
    height: 1470px;
  }
}
@media screen and (max-width: 1364px) {
  .plan-features{
    height: auto;
  }
}
@media screen and (max-width: 1024px) {
  .step-one-content {
    margin-top: 30px;
  }
  .plans-carousel-view {
    display: flex;
    flex-direction: column;
    align-items: center;
    /* overflow: hidden; */
    /* max-width: 100%; */
  }
  .plans-carousel {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    overflow: visible;
    max-width: 100%;
    transition: all 0.5s ease-in-out;
  }
  .plans-carousel.p0{
    transform: translateX(0%);
  }
  .plans-carousel.p1{
    transform: translateX(-100%);
  }
  .plans-carousel.p2{
    transform: translateX(-200%);
  }
  .plans-carousel.p3{
    transform: translateX(-300%);
  }
  .plan-line{
    display: none;
  }
  .plan {
    flex: 0 0 calc(100% - 2px);
    margin: 1px;
    margin-top: 80px;
    justify-content: center;
    align-items: center;
    transition: all 0.3s ease-in-out;
    opacity: 0;
  }
  .plan.active{
    opacity: 1;
  }
  .plan.disabled{
    opacity: 0;
  }
  .plan.active[data-v-3c5ac465] {
    box-shadow: 0 2px 5px 0 #c5c5c5;
  }
  /* .plan:first-of-type{
    opacity: 1;
  } */
  .navigation-dots{
    display: flex;
    justify-content: center;
    margin-top: 10px;
  }
  .dot{
    height: 12px;
    width: 12px;
    background-color: #e6e6e6;
    border-radius: 12px;
    margin: 5px;
  }
  .dot.active{
    background-color: #898989;
  }
  .dot.disabled{
    display: none;
  }
  .list-plan-details {
    padding: 0;
  }
}
@media screen and (max-width: 768px) {
  .step-one-content {
    margin-top: 0;
  }
  .plans-wrapper{
    display: block;
    touch-action: manipulation;
    padding: 0;
  }
  .vip-plan-label {
    font-size: 12px;
    top: -75px;
  }
}
@media screen and (max-width: 620px) {
  #content {
    bottom: 80px;
  }
  .discount-label,
  .discount-label-spacer {
    margin-bottom: 10px;
  }
}
@media screen and (max-width: 480px) {
  .plan-details{
    padding: 0px;
    border: none;
  }
  .button-wrapper{
    flex-direction: column-reverse;
  }
  .plan-features{
    columns: 1;
  }
  .flex-right{
    justify-content: flex-start;
  }
}
</style>
